/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CaptureSummary } from './CaptureSummary';
import {
    CaptureSummaryFromJSON,
    CaptureSummaryFromJSONTyped,
    CaptureSummaryToJSON,
    CaptureSummaryToJSONTyped,
} from './CaptureSummary';

/**
 * 
 * @export
 * @interface CreateManualCaptureResponse
 */
export interface CreateManualCaptureResponse {
    /**
     * 
     */
    capture: CaptureSummary;
}

/**
 * Check if a given object implements the CreateManualCaptureResponse interface.
 */
export function instanceOfCreateManualCaptureResponse(value: object): value is CreateManualCaptureResponse {
    if (!('capture' in value) || value['capture'] === undefined) return false;
    return true;
}

export function CreateManualCaptureResponseFromJSON(json: any): CreateManualCaptureResponse {
    return CreateManualCaptureResponseFromJSONTyped(json, false);
}

export function CreateManualCaptureResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateManualCaptureResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'capture': CaptureSummaryFromJSON(json['capture']),
    };
}

export function CreateManualCaptureResponseToJSON(json: any): CreateManualCaptureResponse {
    return CreateManualCaptureResponseToJSONTyped(json, false);
}

export function CreateManualCaptureResponseToJSONTyped(value?: CreateManualCaptureResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'capture': CaptureSummaryToJSON(value['capture']),
    };
}

